module.exports = __webpack_public_path__ + "static/img/ic_certificate_a.611d2cfa.png";